import config from 'config/app.config'
import { Manager } from 'socket.io-client'

export const manager = new Manager(config.SOCKET_URL)
